import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
};

export const licenseAPI = {
  getMyLicense: () => api.get('/api/licenses/me'),
  getVPNScript: () => api.get('/api/licenses/vpn-script'),
  checkSetup: () => api.post('/api/licenses/check-setup'),
};

export const routerAPI = {
  create: (data) => api.post('/api/routers', data),
  getAll: () => api.get('/api/routers'),
};

export const planAPI = {
  create: (data) => api.post('/api/plans', data),
  update: (id, data) => api.put(`/api/plans/${id}`, data),
  getAll: (routerId) => api.get('/api/plans', { params: { router_id: routerId } }),
  get: (path) => api.get(`/api/plans${path}`),  // Para rutas específicas como /delete-info
  post: (path) => api.post(`/api/plans${path}`),  // Para rutas específicas como /confirm-delete
};

export const pointOfSaleAPI = {
  create: (data) => api.post('/api/points-of-sale', data),
  getAll: (routerId = null) => api.get('/api/points-of-sale', { params: { router_id: routerId } }),
  getOne: (id) => api.get(`/api/points-of-sale/${id}`),
  update: (id, data) => api.put(`/api/points-of-sale/${id}`, data),
  delete: (id) => api.delete(`/api/points-of-sale/${id}`),
};

export const sellerAPI = {
  create: (data) => api.post('/api/sellers', data),
  getAll: (posId = null) => api.get('/api/sellers', { params: { pos_id: posId } }),
  getOne: (id) => api.get(`/api/sellers/${id}`),
  update: (id, data) => api.put(`/api/sellers/${id}`, data),
  delete: (id) => api.delete(`/api/sellers/${id}`),
  addBalance: (id, amount) => api.post(`/api/sellers/${id}/add-balance`, null, { params: { amount } }),
  withdrawBalance: (id, amount) => api.post(`/api/sellers/${id}/withdraw-balance`, { amount }),
};

export const voucherAPI = {
  generate: (data) => api.post('/api/vouchers', data),
  getAll: () => api.get('/api/vouchers'),
  getPdf: (batchId, size = 'a4') => api.get(`/api/vouchers/pdf/${batchId}`, { responseType: 'blob', params: { size } }),
  getPdfHtml: (batchId, size = 'ticket') => api.get(`/api/vouchers/pdf-html/${batchId}`, { responseType: 'blob', params: { size } }),
  getByBatch: (batchId) => api.get(`/api/admin/vouchers/by-batch/${batchId}`),
  getCustomPdf: (voucherIds, size = 'a4') => api.post('/api/vouchers/pdf/custom', { voucher_ids: voucherIds, size }, { responseType: 'blob' }),
};
export const ticketTemplateAPI = {
  list: () => api.get('/api/ticket-templates'),
  create: (data) => api.post('/api/ticket-templates', data),
  update: (id, data) => api.put(`/api/ticket-templates/${id}`, data),
  remove: (id) => api.delete(`/api/ticket-templates/${id}`),
};

// Nuevos endpoints para diseños globales
export const globalDesignAPI = {
  getTicket: () => api.get('/api/design/ticket'),
  updateTicket: (data) => api.put('/api/design/ticket', data),
  getCarta: () => api.get('/api/design/carta'),
  updateCarta: (data) => api.put('/api/design/carta', data),
};

export const dashboardAPI = {
  getStats: () => api.get('/api/dashboard/stats'),
};

export default api;
